// extracted by mini-css-extract-plugin
export var categories = "grid-module--categories--DRT7v";
export var category = "grid-module--category--aT9-A";
export var fadein = "grid-module--fadein--0KJDO";